import { FC, ReactNode, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { TreeItem } from '@mui/x-tree-view';
import { FsRawNode } from '~/api/types';
import { Tooltip } from '~/components';
import { StorageContext } from '~/hooks';
import { FolderTreeItemActions } from '..';
import { folderNameTypographyStyles, folderTreeItemStyles } from './styles';

interface FolderTreeItemProps {
  node: FsRawNode;
  children?: ReactNode;
}

const FolderTreeItem: FC<FolderTreeItemProps> = ({ node, children }) => {
  const storageContext = useContext(StorageContext);
  const isSelectedFolder = storageContext?.lastClickedItem === node.path;

  return (
    <>
      <TreeItem
        key={node.path}
        itemId={node.path}
        label={
          <Box sx={folderTreeItemStyles}>
            <Tooltip title={node.name}>
              <Typography sx={folderNameTypographyStyles(isSelectedFolder)}>{node.name}</Typography>
            </Tooltip>
            {isSelectedFolder && <FolderTreeItemActions path={node.path} />}
          </Box>
        }
      >
        {children}
      </TreeItem>
    </>
  );
};

export default FolderTreeItem;
